import React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-dark text-white pt-4 pb-2 bottom-0" style={{ zIndex: 1000 }}>
      <div className="container">
        <div className="row gy-4">

          {/* Quick Links */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="text-danger fw-semibold fs-5">Quick Links</h5>
            <ul className="list-unstyled mt-3">
              {[
                { label: "Home", path: "/Home" },
                { label: "History", path: "/History" },
                { label: "Management", path: "/Management" },
                { label: "Affiliation", path: "/Affiliation" },
                { label: "Club Facility", path: "/Facility" },
                { label: "Contact", path: "/Contact" },
                // { label: "News Letter", path: "/" },
                { label: "Terms of Use", path: "/Terms" },
                { label: "Privacy Policy", path: "/Privacypolicy" },
                { label: "Return Policy", path: "/Privacypolicy" },
                { label: "Children Privacy Policy", path: "/child-safety-standards" },
              ].map(({ label, path }, i) => (
                <li key={i}>
                  <a
                    onClick={() => navigate(path)}
                    style={{ cursor: "pointer", color: "white", textDecoration: "none" }}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Address */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="text-danger fw-semibold fs-5">Address</h5>
            <div className="mt-3">
              <p className="small mb-2">
                Mahaveer Marg, C-Scheme, Jaipur - 302001 (Raj.)
              </p>
              <p className="small mb-2">
                <strong>Email:</strong> Info@jaiclub.in, jaiclub@hotmail.com
              </p>
              <p className="small mb-0">
                <strong>Phone:</strong> 0141 - 2372321, 2372322
              </p>
            </div>
          </div>

          {/* Guest House Info */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="text-danger fw-semibold fs-5">JaiClub Guest House</h5>
            <div className="mt-3">
              <p className="small mb-2">
                <strong>Phone:</strong> 0141 - 2364472, 2364471
              </p>
              <p className="small mb-0">
                <strong>Email:</strong> Booking@jaiclub.in
              </p>
            </div>
          </div>

          {/* Map */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="text-danger fw-semibold fs-5 mb-3">Location</h5>
            <div className="ratio ratio-4x3">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d113877.92381940318!2d75.69986363906251!3d26.881743559073985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db6a945f27e7d%3A0x573bf52c0d5579df!2sJai%20Club!5e0!3m2!1sen!2sin!4v1749031318310!5m2!1sen!2sin"
                title="Jai Club Location"
                allowFullScreen
                loading="lazy"
                style={{ border: 0 }}
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="text-center mt-4" style={{ fontSize: "0.8em", color: "#B2BABB" }}>
          <hr style={{ borderColor: "grey" }} />
          <p className="mb-0">
            Copyright © {new Date().getFullYear()} JaiClub • All rights reserved
            <br />
            Design by Concept Tek Solution
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
